import * as React from 'react';

import Portal from '../portal';

var NotificationsWrapper = function NotificationsWrapper(_ref) {
    var children = _ref.children;
    return React.createElement(
        Portal,
        { className: 'notifications-wrapper' },
        children
    );
};

NotificationsWrapper.propTypes = {
    children: PropTypes.node
};
export default NotificationsWrapper;
import PropTypes from 'prop-types';